import angular from 'angular';
import onboardingRelatedDocument from './onboardingRelatedDocument';
import './style.scss';

export default angular
  .module('components.onboardingRelatedDocument', [])
  .component('onboardingRelatedDocument', onboardingRelatedDocument).name;
